import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container min-vh-100 d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`errors.${$setup.error}`)), 1)
      ]),
      ($props.retriable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            type: "button",
            onClick: $setup.tryAgain
          }, _toDisplayString(_ctx.$t('actions.tryAgain')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}